import React, { useEffect, useState } from "react";
import OwlCarousel from "react-owl-carousel";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { SendPostRequest } from "../../../http";
import Spinner from "../../Spinner";
import { formatDate, limitParagraphByCharLimit } from "../../../Helper/Helper";

function SecondBlogsGrid() {
  const [blogsData, setBlogsData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    getBlogsData();
  }, []);

  const getBlogsData = async () => {
    setLoading(true);
    try {
      const response = await SendPostRequest("blogs/list");
      setBlogsData(response?.data);
    } catch (error) {
      console.error("Error fetching blogs:", error);
    } finally {
      setLoading(false);
    }
  };

  const options = {
    loop: true,
    nav: false,
    dots: false,
    autoplay: true,
    autoplayTimeout: 2500,
    autoplayHoverPause: true,
    smartSpeed: 1000,
    margin: 30,
    responsive: {
      0: { items: 1 },
      600: { items: 2 },
      1000: { items: 3 },
    },
  };

  // Only render section if there is data and it's not loading
  return (
    <>
      {loading ? (
        <div
          style={{ marginBottom: "100px" }}
          className="d-flex align-items-center justify-content-center "
        >
          <Spinner />
        </div>
      ) : blogsData?.length > 0 ? (
        <section id="services-section" className="services-section semi-dark pt-4 pb-0">
          <div className="container">
            <div className="row">
              <div className="offset-md-2 col-md-8">
                <div className="title-wrap text-center">
                  <div className="section-title margin-bottom-60">
                    <h2 className="section-title margin-top-5 mb-0 text-uppercase">
                      Blogs
                    </h2>

                    <span className="section-border-bottom center"></span>
                  </div>
                </div>
              </div>
              <div className="col-md-12">
                <OwlCarousel className="service-main-wrapper" {...options}>
                  {blogsData?.map((data, index) => (
                    <div className="blog-style-1 post-type post-grid" >
                      <div className="blog-inner mb-4" style={{ height: "420px" }}>
                        <div className="blog-thumb relative">
                          <img
                            src={data?.image}
                            className="img-fluid"
                            style={{ width: "100%", height: "auto" }}
                            alt="blog-img"
                          />
                        </div>
                        <div className="blog-details">
                          <div className="top-meta">
                            <ul className="top-meta-list d-flex">
                              <li>
                                <div className="post-date" style={{ top: "30%" }}>
                                  <a>
                                    <i className="ti-calendar"></i>
                                    {formatDate(data?.date)}
                                  </a>
                                </div>
                              </li>
                            </ul>
                          </div>
                          <div className="blog-title pl-2">
                            <h4 className="margin-bottom-10 mt-3" style={{ fontSize: "19px", lineHeight:"32px" }}>
                              <Link
                                to={`/blog/detail/${data?.slug}`}
                                className="blog-name"
                              >
                                {data?.title}
                              </Link>
                            </h4>
                          </div>
                          <div className="post-desc mt-2 pl-2">
                            <div className="blog-link">
                              <Link
                                to={`/blog/detail/${data?.slug}`}
                                className="link font-w-500"
                              >
                                Read More
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </OwlCarousel>
              </div>
            </div>
          </div>
        </section>
      ) : null}
    </>
  );
}

export default SecondBlogsGrid;
